const BASE_URL = "https://skin-advisor-peru-1091423675326.us-central1.run.app";
let preAnalysisData = null;

  async function addToCart(variantId, quantity = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: quantity
          }
        ]
      })
    });

    document.dispatchEvent(new CustomEvent("cart:refresh"));
    document.dispatchEvent(new CustomEvent("cart:updated"));

    if (!res.ok) {
      throw new Error("Error adding to cart");
    }

    return await res.json();
  }

  async function runPreAnalysis() {
    try {
      const fd = new FormData();

      fd.append("tipo_piel", selectedSkinType || "");
      fd.append("genero", selectedGender || "");
      fd.append("edad", selectedAge || "");

      fd.append("preocupaciones_rostro", JSON.stringify(Array.from(selectedConcerns)));
      fd.append("preocupaciones_ojos", JSON.stringify(Array.from(selectedEyeConcerns)));
      fd.append("preocupaciones_cuello", JSON.stringify(Array.from(selectedNeckConcerns)));

      const ubicacionLatlon =
        document.getElementById("ubicacion_latlon")?.value || "";
      const ubicacionDisplay =
        document.getElementById("ubicacion_display")?.value || "";

      fd.append("ubicacion_latlon", ubicacionLatlon);
      fd.append("ubicacion_display", ubicacionDisplay);

      const resp = await fetch(`${BASE_URL}/pre-analysis`, {
        method: "POST",
        body: fd,
      });

      if (!resp.ok) throw new Error("Pre-analysis failed");

      preAnalysisData = await resp.json();

      // 🔥 Pre-render products immediately (this is the speed win)
      renderProducts(limpiezaProductsEl, preAnalysisData.limpieza_products);
      renderProducts(hidratacionProductsEl, preAnalysisData.hidratacion_products);
      renderProducts(fotoproteccionProductsEl, preAnalysisData.fotoproteccion_products);

    } catch (err) {
      console.error("Pre-analysis error:", err);
    }
  }

  const SHOP_BASE_URL = "https://dermotiendashopping.com/";


  window.formatPrice = function (amount, currency = "CLP") {
    if (amount == null || amount === "") return "";
    const n = Number(amount);
    if (Number.isNaN(n)) return "";
    try {
      return new Intl.NumberFormat("es-CL", { style: "currency", currency }).format(n);
    } catch {
      return `${amount} ${currency}`.trim();
    }
  }

  window.updateLoadingProgress = function (value) {
    const percent = Math.min(Math.max(value, 0), 100); // clamp 0–100
    const fill = document.getElementById("loading-fill");
    const text = document.getElementById("loading-text");

    if (fill) fill.style.width = percent + "%";
    if (text) text.textContent = `Analizando tu piel… ${percent}%`;
  }

  // Intro → Quiz
  window.startQuiz = function () {
    document.getElementById("intro-screen").classList.add("hidden");
    document.getElementById("skin-type-screen").classList.remove("hidden");
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  window.openSkinStep = function () { 
    document.getElementById("intro-screen").classList.add("hidden");
    document.getElementById("skin-type-screen").classList.remove("hidden");
  }

  const PRE_ANALYSIS_URL = `${BASE_URL}/pre-analysis`
  const SELFIE_ANALYSIS_URL = `${BASE_URL}/selfie-analysis`

  // ==== Selfie preview ====
  const selfieInput = document.getElementById("selfie_input");
  const selfiePreview = document.getElementById("selfie_preview");
  let selfieFile = null;

  selfieInput.addEventListener("change", () => {
    const file = selfieInput.files[0];
    if (!file) return;
    selfieFile = file;
    const reader = new FileReader();
    reader.onload = e => {
      selfiePreview.innerHTML = "";
      const img = document.createElement("img");
      img.src = e.target.result;
      selfiePreview.appendChild(img);
    };
    reader.readAsDataURL(file);
  });

  // ==== Handle analyze ====
  const metricsListEl = document.getElementById("metrics_list");
  const envTextEl = document.getElementById("env_text");
  const analisisEl = document.getElementById("analisis_dermatologico");
  const recomendacionesEl = document.getElementById("recomendaciones");
  const rutinaDiaEl = document.getElementById("rutina_dia");
  const rutinaNocheEl = document.getElementById("rutina_noche");
  const alertaEl = document.getElementById("alerta");
  const overlayGridEl = document.getElementById("overlay_grid");
  const limpiezaProductsEl = document.getElementById("limpieza_products");
  const hidratacionProductsEl = document.getElementById("hidratacion_products");
  const fotoproteccionProductsEl = document.getElementById("fotoproteccion_products");

  window.renderMetrics = function (metrics) {
    metricsListEl.innerHTML = "";
    if (!metrics || Object.keys(metrics).length === 0) {
      metricsListEl.innerHTML = "<span style='color:var(--muted);font-size:0.8rem;'>Sin datos de selfie.</span>";
      return;
    }
    Object.entries(metrics).forEach(([key, value]) => {
      const score = parseFloat(value || 0);
      const item = document.createElement("div");
      item.className = "metric-item";
      const niceLabel = key === "skin_score" ? "Puntuación de piel" : key;
      item.innerHTML = `
        <div>${niceLabel}: ${score.toFixed(1)} / 100</div>
        <div class="metric-bar-back">
          <div class="metric-bar-fill" style="width:${Math.max(0, Math.min(100, score))}%"></div>
        </div>
      `;
      metricsListEl.appendChild(item);
    });
  }

  window.renderOverlays = function (overlays)  {
    overlayGridEl.innerHTML = "";
    if (!overlays || overlays.length === 0) {
      overlayGridEl.innerHTML = "<span style='color:var(--muted);font-size:0.8rem;'>Sube una selfie para ver mapas de manchas, ojeras, arrugas y acné.</span>";
      return;
    }
    overlays.forEach(o => {
      const card = document.createElement("div");
      card.className = "overlay-card";
      card.innerHTML = `
        <img src="${o.url}" alt="${o.label}">
        <div>${o.label}</div>
      `;
      overlayGridEl.appendChild(card);
    });
  }

  window.formatPrice = function (amount, currency = "CLP") {
  if (!amount) return "";
  const n = Number(amount);
  if (Number.isNaN(n)) return "";
  return new Intl.NumberFormat("es-CL", {
    style: "currency",
    currency
  }).format(n);
}

  window.renderProducts = function (container, products = []) {
    if (!container) return;
    container.innerHTML = "";

    if (!products.length) {
      const empty = document.createElement("div");
      empty.textContent = "No se encontraron productos recomendados.";
      empty.style.fontSize = "12px";
      empty.style.color = "#777";
      container.appendChild(empty);
      return;
    }

    products.forEach((p) => {
      const card = document.createElement("article");
      card.className = "product-card";

      const title = p.title || p.name || "Producto";
      const image = p.image || p.image_url || "/static/images/product_placeholder.png";
      const handle = p.handle || "";
      const variantId = p.variant_id || "";

      const priceText = formatPrice(p.price_amount, p.price_currency);
      const productUrl = handle ? `${SHOP_BASE_URL}/products/${handle}` : "";

      card.innerHTML = `
        <img src="${image}" alt="${title}">

        <div class="product-name">${title}</div>

        ${priceText ? `<div class="product-price">${priceText}</div>` : ""}

        <button type="button" class="product-add-btn">Agregar al carrito</button>
      `;

      const button = card.querySelector(".product-add-btn");

      button.addEventListener("click", async (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        console.log("ADD TO CART CLICK", variantId);

        if (!variantId) {
          if (productUrl) {
            window.open(productUrl, "_blank", "noopener");
          }
          return;
        }

        try {
          button.disabled = true;
          button.innerText = "Agregando...";

          await addToCart(variantId, 1);

          button.innerText = "✔ Agregado";

          setTimeout(() => {
            button.innerText = "Agregar al carrito";
            button.disabled = false;
          }, 1500);

        } catch (err) {
          console.error(err);
          button.innerText = "Agregar al carrito";
          button.disabled = false;
          alert("No se pudo agregar el producto.");
        }
      });

      container.appendChild(card);
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    // Controles de carrusel para productos AM / PM
    const carouselButtons = document.querySelectorAll(".carousel-btn");

    carouselButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const targetId = btn.dataset.target;           // "am_products" o "pm_products"
        const track = document.getElementById(targetId);
        if (!track) return;

        const carousel = track.parentElement;          // <div class="products-carousel">
        const firstCard = track.querySelector(".product-card");

        // Tamaño de scroll: un producto (con su gap) o el ancho del carrusel
        const cardWidth = firstCard
          ? firstCard.getBoundingClientRect().width + 24 // ajusta si tu gap es otro
          : carousel.clientWidth;

        const direction = btn.classList.contains("next") ? 1 : -1;

        carousel.scrollBy({
          left: direction * cardWidth,
          behavior: "smooth",
        });
      });
    });
  });


  // ==== STEP 1: SKIN TYPE CARDS → SET <select id="tipo_piel"> ====

  let selectedSkinType = null;

  const skinCards = document.querySelectorAll("#skin-type-screen .skin-card");

  skinCards.forEach(card => {
    card.addEventListener("click", () => {
      // remove selected class from all
      skinCards.forEach(c => c.classList.remove("skin-card--selected"));

      // add to clicked
      card.classList.add("skin-card--selected");

      // save selected value from data-skin
      selectedSkinType = card.dataset.skin; // "Mixta", "Normal", etc.
    });
  });

  const skinNextBtn = document.getElementById("skin-next-btn");

  skinNextBtn.addEventListener("click", () => {
    if (!selectedSkinType) {
      alert("Por favor, elige un tipo de piel para continuar.");
      return;
    }

    // Reflect choice in the <select id="tipo_piel"> of the main quiz
    const tipoSelect = document.getElementById("tipo_piel");
    if (tipoSelect && selectedSkinType !== "No lo sé") {
      tipoSelect.value = selectedSkinType;
    }

    // Go to main quiz/app
    document.getElementById("skin-type-screen").classList.add("hidden");
    document.getElementById("concerns-screen").classList.remove("hidden");
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  let selectedConcerns = new Set();
  let selectedEyeConcerns = new Set();
  let selectedNeckConcerns = new Set();

  const concernCards = document.querySelectorAll("#concerns-screen .concern-card");
  const concernNextBtn = document.getElementById("concern-next-btn");

  concernCards.forEach(card => {
    card.addEventListener("click", () => {
      const value = card.dataset.concern;

      // If "Ninguna" selected → clear others
      if (value === "Ninguna") {
        selectedConcerns.clear();
        concernCards.forEach(c => c.classList.remove("concern-card--selected"));
        card.classList.add("concern-card--selected");
        selectedConcerns.add("Ninguna");
        return;
      }

      // If selecting a real concern → remove "Ninguna"
      selectedConcerns.delete("Ninguna");
      concernCards.forEach(c => {
        if (c.dataset.concern === "Ninguna") {
          c.classList.remove("concern-card--selected");
        }
      });

      // Toggle selection
      if (selectedConcerns.has(value)) {
        selectedConcerns.delete(value);
        card.classList.remove("concern-card--selected");
      } else {
        selectedConcerns.add(value);
        card.classList.add("concern-card--selected");
      }
    });
  });


  concernNextBtn.addEventListener("click", () => {
    if (selectedConcerns.size === 0) {
      alert("Por favor, elige al menos una preocupación.");
      return;
    }

    // Ahora sí vamos al quiz/app
    document.getElementById("concerns-screen").classList.add("hidden");
    document.getElementById("eye-neck-concern-screen").classList.remove("hidden");
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  // =============================
  // STEP 3: EYE / NECK CONCERNS (eye-neck-concern-screen)
  // =============================

  // Cards must have class="eye-neck-concern-card"
  // and data-area="eyes" or "neck", plus data-value="Arrugas", etc.

  const eyeCards  = document.querySelectorAll(".eye-neck-concern-card[data-area='eyes']");
  const neckCards = document.querySelectorAll(".eye-neck-concern-card[data-area='neck']");
  const eyeNeckNextBtn = document.getElementById("eye-neck-concern-next-btn");

  window.setupAreaCards = function (cards, selectedSet) {
    cards.forEach(card => {
      card.addEventListener("click", () => {
        const value = card.dataset.value;

        // "Ninguna" logic
        if (value === "Ninguna") {
          selectedSet.clear();
          cards.forEach(c => c.classList.remove("eye-neck-concern-card--selected"));
          card.classList.add("eye-neck-concern-card--selected");
          selectedSet.add("Ninguna");
          return;
        }

        // Remove "Ninguna"
        selectedSet.delete("Ninguna");
        cards.forEach(c => {
          if (c.dataset.value === "Ninguna") {
            c.classList.remove("eye-neck-concern-card--selected");
          }
        });

        // Toggle
        if (selectedSet.has(value)) {
          selectedSet.delete(value);
          card.classList.remove("eye-neck-concern-card--selected");
        } else {
          selectedSet.add(value);
          card.classList.add("eye-neck-concern-card--selected");
        }
      });
    });
  }

  setupAreaCards(eyeCards, selectedEyeConcerns);
  setupAreaCards(neckCards, selectedNeckConcerns);

  eyeNeckNextBtn.addEventListener("click", () => {
    function isValidSelection(set) {
      return set.size > 0;
    }

    if (!isValidSelection(selectedEyeConcerns) || !isValidSelection(selectedNeckConcerns)) {
      alert("Por favor, elige al menos una opción para ojos y cuello.");
      return;
    }

    // 1) Limpia las selecciones actuales de ojos y cuello
    document.querySelectorAll("#concerns_eyes input[type=checkbox], #concerns_neck input[type=checkbox]")
      .forEach(ch => ch.checked = false);

    // 3) Ir al quiz
    document.getElementById("eye-neck-concern-screen").classList.add("hidden");
    document.getElementById("gender-age-screen").classList.remove("hidden");
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  let selectedGender = null;
  let selectedAge = null;

  const genderCards = document.querySelectorAll(".gender-card");
  const ageCards = document.querySelectorAll(".age-card");
  const genderAgeNextBtn = document.getElementById("gender-age-next-btn");

  // ---- GENDER SELECTION ----
  genderCards.forEach(card => {
    card.addEventListener("click", () => {
      genderCards.forEach(c => c.classList.remove("big-card--selected"));
      card.classList.add("big-card--selected");
      selectedGender = card.dataset.gender;
    });
  });

  // ---- AGE SELECTION ----
  ageCards.forEach(card => {
    card.addEventListener("click", () => {
      ageCards.forEach(c => c.classList.remove("small-card--selected"));
      card.classList.add("small-card--selected");
      selectedAge = card.dataset.age;
    });
  });

  genderAgeNextBtn.addEventListener("click", () => {
    if (!selectedGender || !selectedAge) {
      alert("Por favor selecciona tu género y tu rango de edad.");
      return;
    }

    // 👉 Reflejar el rango seleccionado en el <select id="edad"> del quiz
    const edadSelect = document.getElementById("edad");
    if (edadSelect) {
      // Si por algún motivo el valor no existe como option, lo creamos
      let opt = Array.from(edadSelect.options).find(o => o.value === selectedAge);
      if (!opt) {
        opt = document.createElement("option");
        opt.value = selectedAge;
        opt.textContent = selectedAge;
        edadSelect.appendChild(opt);
      }
      edadSelect.value = selectedAge;
    }

    document.getElementById("gender-age-screen").classList.add("hidden");
    document.getElementById("location-screen").classList.remove("hidden");
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  
  document.addEventListener("DOMContentLoaded", () => {
    // botones / labels del STEP LOCATION
    const detectBtn = document.getElementById("loc_detect_btn");
    const cityLabel = document.getElementById("loc_city");
    const uvLabel = document.getElementById("loc_uv");
    const humLabel = document.getElementById("loc_humidity");
    const polLabel = document.getElementById("loc_pollution");
    const nextBtn = document.getElementById("location-next-btn");

    // inputs ocultos ya existentes para el backend
    const ubicacionLatlonInput = document.getElementById("ubicacion_latlon");
    const ubicacionDisplayInput = document.getElementById("ubicacion_display");

    nextBtn.disabled = true;

    async function detectLocation() {
      if (!navigator.geolocation) {
        cityLabel.textContent = "Tu navegador no soporta geolocalización.";
        return;
      }

      cityLabel.textContent = "Detectando ubicación…";

      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          const lat = pos.coords.latitude.toFixed(5);
          const lon = pos.coords.longitude.toFixed(5);

          // guardamos lat,lon para el backend
          ubicacionLatlonInput.value = `${lat},${lon}`;

          try {
            // 👉 llamamos a tu backend /env
            const resp = await fetch(`${BASE_URL}/env?lat=${lat}&lon=${lon}`);
            if (!resp.ok) throw new Error("Error /env " + resp.status);

            const data = await resp.json();
            const env = data.env || {};
            const nice = data.location_display || `Lat ${lat}, Lon ${lon}`;

            // Ciudad / país
            cityLabel.textContent = nice;
            ubicacionDisplayInput.value = nice;

            // ✅ Enable NEXT only after successful detection
            if (ubicacionLatlonInput.value && ubicacionDisplayInput.value) {
              nextBtn.disabled = false;
            }

            // HUMEDAD
            if (env.humidity != null) {
              humLabel.textContent = `${env.humidity}%`;
            } else {
              humLabel.textContent = "--";
            }

            // CALIDAD DE AIRE
            const aqi = env.air_quality;
            const aqiLabel =
              aqi === 1 ? "Buena" :
              aqi === 2 ? "Aceptable" :
              aqi === 3 ? "Moderada" :
              aqi === 4 ? "Mala" :
              aqi === 5 ? "Muy mala" :
              "--";

            polLabel.textContent = aqi ? `AQI ${aqi} (${aqiLabel})` : "--";

            // UV INDEX (texto o número)
            if (env.uv_index != null) {
              uvLabel.textContent = String(env.uv_index);
            } else {
              uvLabel.textContent = "--";
            }
          } catch (e) {
            console.error(e);
            cityLabel.textContent = "No se pudo obtener tu ubicación.";
            uvLabel.textContent = humLabel.textContent = polLabel.textContent = "--";
            nextBtn.disabled = true;
          }
        },
        (err) => {
          console.error(err);
          cityLabel.textContent = "No se pudo obtener tu ubicación.";
          nextBtn.disabled = true;
        },
        { enableHighAccuracy: false, timeout: 8000 }
      );
    }

    // click en "Detectar mi ubicación"
    detectBtn.addEventListener("click", detectLocation);

    // click en SIGUIENTE → pasa al quiz
    nextBtn.addEventListener("click", () => {
      document.getElementById("location-screen").classList.add("hidden");
      document.getElementById("photo-screen").classList.remove("hidden");
      runPreAnalysis();
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  });

  // ====== SELFIE SCREEN =======
  document.addEventListener("DOMContentLoaded", () => {

    const selfieDrop = document.getElementById("selfie_drop");
    const selfieInput = document.getElementById("selfie_input");
    const selfiePreview = document.getElementById("selfie_preview");
    const selfieNextBtn = document.getElementById("selfie-next-btn");

    // CLICK → abrir selector de archivos
    selfieDrop.addEventListener("click", () => selfieInput.click());

    // INPUT → archivo elegido
    selfieInput.addEventListener("change", e => {
      const file = e.target.files[0];
      if (file) loadSelfie(file);
    });

    // DRAG OVER → highlight
    selfieDrop.addEventListener("dragover", e => {
      e.preventDefault();
      selfieDrop.style.borderColor = "#ff641c";
    });

    selfieDrop.addEventListener("dragleave", () => {
      selfieDrop.style.borderColor = "#ccc";
    });

    // DROP → cargar archivo
    selfieDrop.addEventListener("drop", e => {
      e.preventDefault();
      selfieDrop.style.borderColor = "#ccc";
      const file = e.dataTransfer.files[0];
      if (file) loadSelfie(file);
    });

    // FUNCIÓN PARA MOSTRAR LA IMAGEN
    function loadSelfie(file) {
      selfieFile = file;

      const reader = new FileReader();
      reader.onload = () => {
        selfiePreview.innerHTML = `<img src="${reader.result}" />`;
        selfiePreview.classList.remove("hidden");
        selfieDrop.classList.add("hidden");
      };
      reader.readAsDataURL(file);
    }

    
  });

  // ===== VARIABLES GLOBALES =====
  const selfieMainEl = document.getElementById("results-selfie-main");
  const overlaysContainer = document.getElementById("overlays-container");

  // ====== UTILIDADES ======

  window.renderOverlays = function (overlays) {
    overlaysContainer.innerHTML = "";
    if (!overlays || !overlays.length) {
      selfieMainEl.src = "";
      return;
    }

    // primera imagen
    selfieMainEl.src = overlays[0].url;

    overlays.forEach((o, idx) => {
      const btn = document.createElement("button");
      btn.textContent = o.label;
      if (idx === 0) btn.classList.add("active");

      btn.addEventListener("click", () => {
        selfieMainEl.src = o.url;
        document.querySelectorAll("#overlays-container button")
          .forEach(b => b.classList.remove("active"));
        btn.classList.add("active");
      });

      overlaysContainer.appendChild(btn);
    });
  }

  window.renderSkinMetrics = function (metrics) {
    const container = document.getElementById("skin-metrics");
    container.innerHTML = "";

    if (!metrics) return;

    Object.entries(metrics).forEach(([label, value]) => {
      if (label === "skin_score") return; // evitar duplicado

      const row = document.createElement("div");
      row.className = "metric-item";

      row.innerHTML = `
        <div class="metric-label">${label}: ${Math.round(value)} / 100</div>
        <div class="metric-bar">
          <div class="metric-bar-fill" style="width:${Math.round(value)}%"></div>
        </div>
      `;

      container.appendChild(row);
    });
  }

  document.querySelectorAll(".carousel-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      const targetId = btn.dataset.target;
      const track = document.getElementById(targetId);
      if (!track) return;

      const card = track.querySelector(".product-card");
      const step = card ? card.offsetWidth + 16 : 220;

      const direction = btn.classList.contains("next") ? 1 : -1;
      track.scrollBy({
        left: direction * step,
        behavior: "smooth",
      });
    });
  });

  // ====== REFERENCIAS GLOBALES CORRECTAS ======
  const analyzeBtn = document.getElementById("selfie-next-btn"); // botón "GENERAR ANÁLISIS"
  const statusLabel = document.getElementById("status_label");    // si no existe, crea un <p id="status_label">

  // inputs ocultos de ubicación
  const ubicacionLatlonInput   = document.getElementById("ubicacion_latlon");
  const ubicacionDisplayInput  = document.getElementById("ubicacion_display");

  let progressTimer = null;
  let currentProgress = 0;

  window.startProgress = function () {
    currentProgress = 0;
    updateLoadingProgress(0);

    progressTimer = setInterval(() => {
      if (currentProgress < 90) {
        const increment = Math.floor(Math.random() * 3) + 1; // 1–3%
        currentProgress = Math.min(currentProgress + increment, 90);
        updateLoadingProgress(currentProgress);
      } else {
        clearInterval(progressTimer);
        progressTimer = null;
      }
    }, 150);
  }

  window.completeProgress = function () {
    if (progressTimer) {
      clearInterval(progressTimer);
      progressTimer = null;
    }
    updateLoadingProgress(100);
  }

  // ====== BOTÓN ANALIZAR ======
  analyzeBtn.addEventListener("click", async () => {
    const loadingOverlay = document.getElementById("loading-overlay");

    // texto resultados
    //const analisisEl        = document.getElementById("analisis_text");
    //const recomendacionesEl = document.getElementById("recomendaciones_text");
    //const rutinaDiaEl       = document.getElementById("rutina_dia_text");
    //const rutinaNocheEl     = document.getElementById("rutina_noche_text");
    //const alertaEl          = document.getElementById("alerta_text");

    // productos por categoría
    const limpiezaProductsEl        = document.getElementById("limpieza_products");
    const hidratacionProductsEl     = document.getElementById("hidratacion_products");
    const fotoproteccionProductsEl  = document.getElementById("fotoproteccion_products");

    // score
    const skinScoreEl = document.getElementById("skin-score-value");

    // ===== TOMAR VALORES DESDE LAS VARIABLES DEL QUIZ =====
    // vienen de los steps: skin, concerns, eyes/neck, gender, age, location
    const tipo_piel  = selectedSkinType  || "";   // "Mixta", "Seca", etc.
    const genero     = selectedGender    || "";   // "Mujer", "Hombre", etc.
    const edad       = selectedAge       || "";   // "25-34", etc.

    const preocupaciones_rostro = Array.from(selectedConcerns);
    const preocupaciones_ojos   = Array.from(selectedEyeConcerns);
    const preocupaciones_cuello = Array.from(selectedNeckConcerns);

    const ubicacion_latlon  = ubicacionLatlonInput  ? ubicacionLatlonInput.value  : "";
    const ubicacion_display = ubicacionDisplayInput ? ubicacionDisplayInput.value : "";

    // selfieFile debe ser GLOBAL (no declarar "let selfieFile" otra vez dentro de DOMContentLoaded)
    if (!selfieFile) {
      if (statusLabel) {
        statusLabel.textContent = "Por favor, sube una selfie antes de analizar.";
        statusLabel.classList.add("error");
      } else {
        alert("Por favor, sube una selfie antes de analizar.");
      }
      return;
    }

    if (statusLabel) {
      statusLabel.textContent = "Analizando tu piel con IA...";
      statusLabel.classList.remove("error");
    }
    analyzeBtn.disabled = true;
    analyzeBtn.innerHTML = `<span class="icon">⏳</span>Procesando...`;

    loadingOverlay.classList.remove("hidden");

    startProgress();

    try {

      const fd = new FormData();
      fd.append("tipo_piel", tipo_piel);
      fd.append("genero", genero);
      fd.append("edad", edad.toString());
      fd.append("preocupaciones_rostro", JSON.stringify(preocupaciones_rostro));
      fd.append("preocupaciones_ojos",   JSON.stringify(preocupaciones_ojos));
      fd.append("preocupaciones_cuello", JSON.stringify(preocupaciones_cuello));
      fd.append("ubicacion_latlon", ubicacion_latlon);
      fd.append("ubicacion_display", ubicacion_display);
      fd.append("selfie", selfieFile);


      const resp = await fetch(SELFIE_ANALYSIS_URL, {
        method: "POST",
        body: fd
      });

      if (!resp.ok) throw new Error("Error de servidor: " + resp.status);

      const data = await resp.json();

      // ----- RELLENAR RESULTADOS -----
      let rawScore = data.metrics?.skin_score;
      let skinScore = rawScore != null
        ? Math.max(30, Math.round(rawScore))
        : "--";

      skinScoreEl.textContent = skinScore;

      renderSkinMetrics(data.metrics);

      //analisisEl.textContent        = data.analisis_dermatologico || "";
      //recomendacionesEl.textContent = data.recomendaciones        || "";
      //rutinaDiaEl.textContent       = data.rutina_dia             || "";
      //rutinaNocheEl.textContent     = data.rutina_noche           || "";
      //alertaEl.textContent          = data.alerta                 || "";

      renderOverlays(data.overlays);

      // ensure limpieza tab is active on first load
      document.querySelectorAll(".category-tab").forEach(t => t.classList.remove("active"));
      document.querySelectorAll(".products-category").forEach(c => c.classList.remove("active"));

      document.querySelector('.category-tab[data-target="limpieza"]')?.classList.add("active");
      document.getElementById("category-limpieza")?.classList.add("active");

      // Cambiar pantalla
      document.getElementById("photo-screen").classList.add("hidden");
      document.getElementById("results-screen").classList.remove("hidden");
      window.scrollTo({ top: 0, behavior: "smooth" });

      completeProgress();

    } catch (err) {
      console.error(err);
      completeProgress();
      if (statusLabel) {
        statusLabel.textContent = "Ocurrió un error al procesar tu análisis.";
        statusLabel.classList.add("error");
      } else {
        alert("Ocurrió un error al procesar tu análisis.");
      }
    } finally {
      analyzeBtn.disabled = false;
      analyzeBtn.innerHTML = `<span class="icon">✨</span>Analizar mi piel`;

      setTimeout(() => {
        loadingOverlay.classList.add("hidden");
      }, 400);
      
      loadingOverlay.classList.add("hidden");
    }
  });

  // ===== PRODUCT CATEGORY TABS =====
  document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll(".category-tab");
  const categories = document.querySelectorAll(".products-category");

  if (!tabs.length || !categories.length) return;

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      const target = tab.dataset.target;

      // activate tab
      tabs.forEach(t => t.classList.remove("active"));
      tab.classList.add("active");

      // show category
      categories.forEach(cat => {
        cat.classList.toggle(
          "active",
          cat.id === `category-${target}`
        );
      });
    });
  });
});